import { PrintSelectImageData } from "../../../components/pages/sift/print-select-images/hooks/use-print-select-images";
import { DateFormatter } from "../../../utilities/date-formatter";

type PrintSelectImageSortType = 'name_ask'
  | 'name_desc'
  | 'date_ask'
  | 'date_desc';

export const printSelectImageSort: { label: string, value: PrintSelectImageSortType, sort: (data: PrintSelectImageData[]) => void }[] = [
  { value: 'name_ask', label: 'ファイル名でソート(昇順)', sort: (data: PrintSelectImageData[]) => {
    try {
      data.sort((a, b) => {
        return a.orgFilename > b.orgFilename ? 1 : -1;
      })
    } catch(e) {}
  } },
  { value: 'name_desc', label: 'ファイル名でソート(降順)', sort: (data: PrintSelectImageData[]) => {
    try {
      data.sort((a, b) => {
        return a.orgFilename > b.orgFilename ? -1 : 1;
      })
    } catch(e) {}

  } },
  { value: 'date_ask', label: '日付でソート(昇順)', sort: (data: PrintSelectImageData[]) => {
    try {
      data.sort((a, b) => {
        const aDate = DateFormatter.str2date(a.exifCreated || DateFormatter.date2str(new Date()))?.getTime() ?? 0;
        const bDate = DateFormatter.str2date(b.exifCreated || DateFormatter.date2str(new Date()))?.getTime() ?? 0;
        return aDate > bDate ? 1 : -1;        
      })
    } catch(e) {}

  } },
  { value: 'date_desc', label: '日付でソート(降順)', sort: (data: PrintSelectImageData[]) => {
    try {
      data.sort((a, b) => {
        const aDate = DateFormatter.str2date(a.exifCreated || DateFormatter.date2str(new Date()))?.getTime() ?? 0;
        const bDate = DateFormatter.str2date(b.exifCreated || DateFormatter.date2str(new Date()))?.getTime() ?? 0;
        return aDate > bDate ? -1 : 1;
      });
    } catch(e) {
    }
  } },
];